import React, {useEffect} from 'react';
import {useI18nContext} from "../../contexts/I18nContext";
import {useStyles} from "./BillingPeriod.style";
import Box from "../../ui_components/Box/Box";
import Width from "../../ui_components/common/enums/Width";
import Alignment from "../../ui_components/common/enums/Alignment";
import FilterInput from "../../shared_components/Inputs/FilterInput/FilterInput";
import Button from "../../ui_components/Button/Button";
import {Observer} from "mobx-react-lite";
import ShowPagination from "../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import BillingPeriodRow from "./BillingPeriodRow/BillingPeriodRow";
import BillingPeriodStore from "./BillingPeriodStore";
import {useCommonContext} from "../../contexts/CommonContext";
import ButtonType from "../../ui_components/Button/ButtonType";
import useOnEnterPress from '../../hooks/EnterPress';
import NewBillingPeriodButton from '../../shared_components/Buttons/NewBillingPeriodButton/NewBillingPeriodButton';


const BillingPeriod: React.FC = () => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const billingPeriodStore = new BillingPeriodStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        billingPeriodStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await billingPeriodStore.getElements();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await billingPeriodStore.goToPage(page, pageSize);
    }

    const onBillingPeriodSearch = () => {
        billingPeriodStore.search()
    }
    useOnEnterPress(onBillingPeriodSearch,[billingPeriodStore]);

    return (
        <Observer>
            {() => (
                <div className={classes.billing_periods_container}>
                    <Box className={classes.tools_container}
                         width={Width.FULL_WIDTH}
                         justifyContent={Alignment.END}
                    >
                        <NewBillingPeriodButton type={ButtonType.SECONDARY} onSave={onUpdate}/>
                    </Box>
                    <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                         justifyContent={Alignment.SPACE_BETWEEN}>
                        <FilterInput value={billingPeriodStore.filter}
                                     placeholder={i18n.translate("BILLING_PERIOD_FILTER_PLACEHOLDER")}
                                     onChange={(value) => {
                                         billingPeriodStore.setFilter(value)
                                     }} onEnter={() => billingPeriodStore.search()}/>
                        <Button
                            onClick={onBillingPeriodSearch}
                            className={classes.search_btn}
                            text={i18n.translate("SEARCH")}
                        />
                    </Box>
                    {!billingPeriodStore.isEmpty &&
                    <div className={classes.billing_periods_table}>
                        <ShowPagination onChange={onPaginationChange}
                                        elementLabel={i18n.translate("BILLING_PERIODS")}
                                        pagination={billingPeriodStore.pagination}/>
                        <div className={classes.elements_container}>
                            {billingPeriodStore.billingPeriods.map((billingPeriod, i) => (
                                <BillingPeriodRow
                                    onUpdate={onUpdate}
                                    billingPeriod={billingPeriod}
                                    key={i}
                                />
                            ))}
                        </div>
                        <ShowPagination
                            onChange={onPaginationChange}
                            elementLabel={i18n.translate("BILLING_PERIODS")}
                            pagination={billingPeriodStore.pagination}/>
                    </div>}
                    {billingPeriodStore.isEmpty &&
                    <MessageCard icon={AccountBoxSharpIcon} title={i18n.translate("NO_BILLING_PERIODS_TITLE")}
                                 subtitle={i18n.translate("NO_BILLING_PERIODS_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default BillingPeriod;
